module.exports = __webpack_public_path__ + "static/media/location.f2c2c7c8.png";